export const variants = {
  getVariantLearnMore: (state) => (learnMoreVariant) => {
    if (!learnMoreVariant) return null;
    const variant = getVariant(state, learnMoreVariant);
    if (!variant || !variant.modal_header) return null;
    return {
      header: variant.modal_header,
      body: variant.modal_body,
      image: variant.modal_image,
    };
  },
  getVariantShippingNote: (state) => (itemId) => {
    const variant = getVariant(state, itemId);
    if (!variant) return "";
    return variant.shipping_note;
  },
  getVariantCutOutImage: (state) => (itemId) => {
    const variant = getVariant(state, itemId);
    if (!variant) return "";
    return variant.image;
  },
  getVariantQuantityLimit: (state) => (itemId) => {
    const variant = getVariant(state, itemId);
    if (!variant) return null;
    return variant.item_quantity_limit;
  },
  getVariantPrice: (state) => (variantId) => {
    const variant = getVariant(state, variantId);
    if (!variant) return null;
    return variant.price;
  },
  getVariantCompareAtPrice: (state) => (variantId) => {
    const variant = getVariant(state, variantId);
    if (!variant) return null;
    return variant.compare_at_price;
  },
  getVariantSetPrice: (state) => (variantId) => {
    const variant = getVariant(state, variantId);
    if (!variant) return null;
    return variant.set_price;
  },
  getVariantSetCompareAtPrice: (state) => (variantId) => {
    const variant = getVariant(state, variantId);
    if (!variant) return null;
    return variant.set_compare_at_price;
  },
  getProperties:
    (state, getters) =>
    (variantId, properties = {}) => {
      const variant = getVariant(state, variantId);
      if (!variant) return null;
      properties._created_at = Date.now();
      if (getters.getVariantShippingNote(variantId)) {
        properties._preorder = true;
      }
      return properties;
    },
};

const getVariant = (state, _id) => {
  return state.variants.find(({ id }) => parseInt(id) === parseInt(_id));
};
